import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(main)/blog/series/[slug]/error.tsx");
